import { SET_AUTHENTICATION_TOKEN } from "src/app/reducers/AuthenticationReducer";
import type { ThunkResult } from "src/app/reducers/IMainAppState";
import type {
  AuthenticationAccessRight,
  AuthenticationToken,
} from "src/authentication/objects/AuthenticationToken";
import { AUTHENTICATION_API_PATH } from "src/confs/APIConfig";
import { GetMerchantGroups } from "src/merchantgroups/actions/MerchantGroupActionCreators";
import type MerchantGroup from "src/merchantgroups/objects/MerchantGroup";
import { GetMerchants } from "src/merchants/actions/MerchantActionCreators";
import type Merchant from "src/merchants/objects/Merchant";
import { APIPost } from "src/shared/actions/FetchActions";

export function SetAuthenticationToken(
  authenticationToken: AuthenticationToken,
): ThunkResult<void> {
  return (dispatch) => {
    dispatch({
      type: SET_AUTHENTICATION_TOKEN,
      authenticationToken,
    });
  };
}

export function RemoveAuthenticationToken(): ThunkResult<void> {
  return (dispatch, getState) => {
    getState().app.removeAuthenticationTokenHandler();
  };
}

export function InvalidateAuthenticationToken(
  authenticationToken: AuthenticationToken,
): ThunkResult<Promise<object>> {
  return async (dispatch) => {
    const fetchResult: Response = await dispatch(
      APIPost(`${AUTHENTICATION_API_PATH}/action/_logout`, {
        body: JSON.stringify({
          authenticationToken: authenticationToken.authenticationToken,
        }),
      }),
    );
    return await fetchResult.json();
  };
}

export function GatherAccessInfo(
  authenticationToken: AuthenticationToken,
): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    if (authenticationToken.menuDisplayLevel === 1) {
      const merchantGroups: MerchantGroup[] = await dispatch(
        GetMerchantGroups(authenticationToken),
      );
      authenticationToken.merchantGroupUUID =
        merchantGroups[0].merchantGroupUUID;
    } else if (
      authenticationToken.menuDisplayLevel === 2 ||
      authenticationToken.menuDisplayLevel === 4
    ) {
      const merchants: Merchant[] = await dispatch(
        GetMerchants(undefined, authenticationToken),
      );
      authenticationToken.merchantUUID = merchants[0].merchantUUID;
    }
  };
}

export function CanAccess(
  accessRight: AuthenticationAccessRight | AuthenticationAccessRight[],
): ThunkResult<boolean> {
  return (dispatch, getState) => {
    const authenticationToken: AuthenticationToken | undefined =
      getState().authentication.authenticationToken;
    if (!authenticationToken) {
      return false;
    }

    return authenticationToken.canAccess(accessRight);
  };
}
